// Taken from certell-web-api
import * as contentful from 'contentful';

export const SPACE_ID = process.env.SPACE_ID;

export const deliveryClient =
  process.env.CONTENT_DELIVERY_ACCESS_TOKEN
    ? contentful.createClient({ space: SPACE_ID, accessToken: process.env.CONTENT_DELIVERY_ACCESS_TOKEN })
    : null;

export const previewClient =
  process.env.CONTENT_PREVIEW_ACCESS_TOKEN
    ? contentful.createClient({
        space: SPACE_ID,
        accessToken: process.env.CONTENT_PREVIEW_ACCESS_TOKEN,
        environment_id: 'master',
        host: 'preview.contentful.com'
      })
    : null;
